import { Component } from '@opten/compiler/metadata/component';
import {
	ArcElement,
	BarController,
	BarElement,
	CategoryScale,
	Chart,
	DoughnutController,
	Legend,
	LinearScale,
	LineController,
	LineElement,
	PointElement,
	Title,
	Tooltip
} from 'chart.js';
import ChartDeferred from 'chartjs-plugin-deferred';
import { color } from 'chart.js/helpers';

Chart.register(
	ArcElement,
	BarElement,
	BarController,
	CategoryScale,
	DoughnutController,
	Legend,
	LinearScale,
	LineElement,
	LineController,
	PointElement,
	Title,
	Tooltip,
	ChartDeferred
);
const bodyStyles = getComputedStyle(document.body);
Chart.defaults.font = {
	family: bodyStyles.fontFamily,
	size: parseInt(bodyStyles.fontSize),
	weight: bodyStyles.fontWeight
};

@Component({ className: 'js-chart' })
export class ChartComponent {
	private static Colors = [
		'#ffd300',
		'#000',
		'#273583',
		'#d10a11',
		'#3fa535'
	];

	constructor(private element: HTMLCanvasElement) {
		const tooltipDisabled: any =
			this.element.getAttribute('data-hide-tooltip') == 'true' ||
			this.element.getAttribute('data-hide-tooltip') == 'True';
		const type: any = this.element.getAttribute('data-type');
		const sameScale =
			this.element.getAttribute('data-same-scale') == 'true';
		const labels = JSON.parse(this.element.getAttribute('data-labels'));
		const datasets: any[] = JSON.parse(
			this.element.getAttribute('data-datasets')
		);

		let title = undefined;
		if (datasets.length == 1) {
			title = {
				display: true,
				text: datasets[0].label
			};
		}

		let scales = undefined;
		if (sameScale == false) {
			scales = datasets.reduce((map, dataset, i) => {
				const yLabel = 'y' + i;
				dataset.yAxisID = yLabel;
				map[yLabel] = {
					type: 'linear',
					position: i % 2 == 0 ? 'left' : 'right',
					grid: {
						drawOnChartArea: i == 0
					}
				};
				return map;
			}, {});
		}

		datasets.map((dataset, i) => {
			if (type == 'doughnut') {
				dataset.backgroundColor = this.getColors(
					color(ChartComponent.Colors[0]),
					labels.length
				);
			} else {
				dataset.backgroundColor = this.getColor(i);
				dataset.pointRadius = 10;
			}
		});

		const chart = new Chart(this.element, {
			type,
			data: {
				labels,
				datasets
			},
			options: {
				scales,
				plugins: {
					title,
					legend: {
						position: 'bottom'
					},
					tooltip: {
						enabled: !tooltipDisabled
					},
					deferred: {
						yOffset: '50%'
					}
				}
			}
		});
	}

	private getColor(index: number) {
		return ChartComponent.Colors[index % ChartComponent.Colors.length];
	}

	private getColors(startColor, size: number) {
		const startColors = startColor.rgb;
		const endColors = startColor.lighten(1).rgb;
		const colors = [];
		for (let index = 0; index < size; index++) {
			var r = this.interpolate(startColors.r, endColors.r, size, index);
			var g = this.interpolate(startColors.g, endColors.g, size, index);
			var b = this.interpolate(startColors.b, endColors.b, size, index);
			colors.push(`rgb(${r}, ${g}, ${b})`);
		}
		return colors;
	}

	private interpolate(start, end, steps, count) {
		var s = start,
			e = end,
			final = s + ((e - s) / steps) * count;
		return Math.floor(final);
	}
}
